module.exports = __webpack_public_path__ + "img/ic_white_catalunia.aa393b05.svg";